module.exports = __webpack_public_path__ + "static/media/dinosaur(14).99fa140a.PNG";